import { render, staticRenderFns } from "./AddOrderType.vue?vue&type=template&id=8fb650c8&scoped=true"
import script from "./AddOrderType.vue?vue&type=script&lang=js"
export * from "./AddOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb650c8",
  null
  
)

export default component.exports